import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScoreService {
  score: string[][] = [];
  constructor() {
    this.score = JSON.parse(sessionStorage.getItem('scoreItems')) || [];
  }

  public addScore(id: string, value: number) {
    this.score.push([id, `${value}`]);
    sessionStorage.setItem('scoreItems', JSON.stringify(this.score));
  }

  public deleteScore() {
    this.score = [];
    sessionStorage.removeItem('scoreItems');
  }
}
